import { render, staticRenderFns } from "./MetaImport.vue?vue&type=template&id=05f05738&scoped=true&"
import script from "./MetaImport.vue?vue&type=script&lang=js&"
export * from "./MetaImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f05738",
  null
  
)

export default component.exports